export default function HunyuanLogo() {
  return <img src="/logos/hunyuan-logo.png" alt="Tencent Hunyuan" width="16" height="16" className="block" />
}
